const REMOTE_THEME_ETAG_KEY = 'eduzz-ui-remote-theme-etag';
const REMOTE_THEME_VALUE_KEY = 'eduzz-ui-remote-theme-value';

export function getRemoteThemeParam(): string {
  return new URLSearchParams(window.location.search).get('remoteTheme') ?? 'default';
}

/**
 * Garante que o remoteTheme da query string consiga selecionar o tema certo.
 * O @eduzz/ui-antd-theme usa etag + localStorage; se o etag existir sem o JSON
 * (ou com JSON antigo), o fetch retorna fallback (#0d2772) e ignora ?remoteTheme=.
 */
export function ensureRemoteThemeCache(): void {
  try {
    const etag = localStorage.getItem(REMOTE_THEME_ETAG_KEY);
    const value = localStorage.getItem(REMOTE_THEME_VALUE_KEY);
    const remoteTheme = getRemoteThemeParam();

    if (etag && !value) {
      localStorage.removeItem(REMOTE_THEME_ETAG_KEY);
    }

    if (remoteTheme !== 'default' && value) {
      const parsed = JSON.parse(atob(value)) as { themes?: Record<string, unknown> };

      if (!parsed?.themes?.[remoteTheme]) {
        localStorage.removeItem(REMOTE_THEME_ETAG_KEY);
        localStorage.removeItem(REMOTE_THEME_VALUE_KEY);
      }
    }
  } catch {
    localStorage.removeItem(REMOTE_THEME_ETAG_KEY);
    localStorage.removeItem(REMOTE_THEME_VALUE_KEY);
  }
}
